import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as Yup from 'yup';
import { addDescriptionActionHighlight, createActionHighlight, getActionHighlighterIds, getActionHighlighterIdsSuccess, getActionId, getActionIdSuccess, getAllTemplateChecklist } from "../../../store/actions/action.Highlighters";
import { Box, Button, Divider, Card, Link, Flex, Paragraph, Spinner, Text, Textarea, useColorMode } from "theme-ui";
import { FaPlus } from "react-icons/fa";
import { ActionCard } from "./ActionCard";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ActionModuleTabProps, RootState } from "../../../../@types";
import CustomTooltip from "../../CustomTooltip";
import { rolePermissionsHighLighters } from "../../../utils/CustomHandler";
import toast from "react-hot-toast";
import theme from "../../../theme";
import moment from "moment";

export const ActionModuleTab = ({ actionObject, selectedHighlight, keys, children, actionId, handleHighlightClick, isCompleted = false, isActive = true }: ActionModuleTabProps) => {
  const dispatch = useDispatch()
  const { actionHighlights, createHighlight, loader, bcActionDone, templateList } = useSelector((state: any) => state.actionHighlight)
  const { stagesView, tasksView } = useSelector((state: any) => state.project);
  const [highlighter, setHighlighter] = useState<any>(null);
  const { pathname } = useLocation();
  const { stageId } = useParams<{ stageId: string }>();
  const { auther } = useSelector((state: RootState) => state.auth);
  const [showWarning, setShowWarning] = useState(false);
  const is_Task_Worker = auther?.Role?.map(role => role?.RoleName).every(role => role.toLocaleLowerCase() === "task worker")
  // const [selectedTemplates, setSelectedTemplates] = useState<any>();
  // const templateOptions: any = templateList?.map((template: IChecklistTemplate) => ({
  //   label: template.templateName,
  //   value: template._id,
  //   checklistItem: template?.checklistItem
  // }));
  const [colorMode] = useColorMode();
  const modalHeader = colorMode === 'light' ? "#f6f6f6" : "#282e42";
  const titleHeader = colorMode === 'light' ? "black" : "#dadada";
  const isStageMatch = stageId === actionHighlights?.stageId;
  const canAddTask =
    !(isStageMatch === false &&
      ["Revision", "Background Change", "Plan Check"]?.includes(selectedHighlight?.name || ""));

  let objKeys = keys?.second !== undefined ? {
    name: '',
    [keys?.first]: false,
    [keys?.second]: false,
    comment: [],

  } : {
    name: '',
    [keys?.first]: false,
    comment: []
  }

  const actionProjId = actionObject?.projectId;
  const actionStageId = actionObject?.stageId;
  const actionTaskId = actionObject?.taskId;

  const actionDocTaskId = actionHighlights?.taskId?._id || actionHighlights?.taskId || null;
  const isDocMatch = Boolean(
    actionHighlights?._id &&
    (actionId ? actionHighlights._id === actionId : (
      actionHighlights?.actionType === selectedHighlight?.name &&
      String(actionDocTaskId || '') === String(actionTaskId || '')
    ))
  );
  useEffect(() => {
    if (!isActive) return;

    if (actionId) {
      dispatch(getActionId(actionId))

    }
    else {
      dispatch(getActionHighlighterIds(actionObject, { name: selectedHighlight?.name || "" }))
    }
    dispatch(getAllTemplateChecklist({ query: "subtasks" }))

  }, [bcActionDone, selectedHighlight, isActive, actionProjId, actionStageId, actionTaskId])

  useEffect(() => {
    if (stagesView?.highlighters && pathname?.split('/')[1] === 'edit-stages') {
      setHighlighter(stagesView?.highlighters)
    }
    if (tasksView.highlighters && pathname?.split('/')[1] === 'edit-task') {
      setHighlighter(tasksView?.highlighters)
    }
  }, [stagesView?.highlighters, tasksView?.highlighters]);

  useEffect(() => {
    return () => {
      dispatch(getActionHighlighterIdsSuccess([]))
      dispatch(getActionIdSuccess([]))
      setHighlighter(null)
    }
  }, [])

  useEffect(() => {
    if (selectedHighlight?.name === 'New Info Added' && isDocMatch && actionHighlights?.payload?.Description?.length > 0) {
      setShowWarning(true);
      if (stagesView?.highlighters) {
        setHighlighter(stagesView?.highlighters)
      }
      if (tasksView?.highlighters) {
        setHighlighter(tasksView?.highlighters)
      }
    } else {
      setShowWarning(false);
    }
  }, [selectedHighlight, actionHighlights, isDocMatch, stagesView?.highlighters, tasksView?.highlighters]);


  const [attachments, setAttachments] = useState<string[]>([]);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string>("");

  const formik = useFormik(
    {
      enableReinitialize: true,
      initialValues: objKeys,
      validationSchema: Yup.object({
        name: Yup.string().required('Check list item is required'),
      }),
      onSubmit: (value: any) => {

        // if (!is_Task_Worker && rolePermissionsHighLighters.includes(selectedHighlight?.name)) {
        value["isReviewed"] = false;
        value["isDone"] = false;
        value["toDisplay"] = false;
        value["attachment"] = [];
        if (isDocMatch) {
          const updateData = {
            data: value,
            ...actionObject,
            actionType: selectedHighlight?.name,
          }

          dispatch(addDescriptionActionHighlight(updateData, actionHighlights?._id))
        } else {
          const payload = {
            actionType: selectedHighlight?.name,
            payload: {
              Description: [value]
            },
            ...actionObject
          }
          dispatch(createActionHighlight(payload))
        }
        setAttachments([]);
        formik.resetForm()
        // }

      }
    }
  );
  const { handleSubmit, setFieldValue, values, handleBlur, touched, errors } = formik;
  const placeholderText = `Create ${selectedHighlight?.name?.toLowerCase()} subtask`;
  const [textareaValue, setTextareaValue] = useState(values.name);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [textareaValue]);

  // const handleTemplateChange = (selected: any) => {
  //   const selectedTemplates = {
  //     _id: selected?.value?._id,
  //     name: selected?.value?.templateName,
  //   };

  //   if (actionHighlights?._id) {
  //     const data = selected?.checklistItem.map((template: any) => ({
  //       name: template,
  //       isChecked: false,
  //       isReviewed: false,
  //       isDone: false,

  //     }));

  //     const updateData = {
  //       data,
  //       ...actionObject,
  //       actionType: selectedHighlight?.name,
  //     };
  //     // Dispatch the action with the formatted payload
  //     dispatch(addDescriptionBulkActionHighlight(updateData, actionHighlights?._id));
  //   } else {
  //     const description = selected?.checklistItem.map((template: any) => ({
  //       name: template,
  //       isChecked: false,
  //       isBlockByInfo: false,
  //       comment: [],
  //       isReviewed: false,
  //       isDone: false,

  //     }));

  //     const payload = {
  //       actionType: selectedHighlight?.name,
  //       payload: {
  //         Description: description,
  //       },
  //       ...actionObject,
  //     };

  //     dispatch(createActionHighlight(payload));
  //   }

  //   setSelectedTemplates(selectedTemplates);
  // };

  const handleTextareaChange = (event: any) => {
    const newValue = event.target.value;
    setTextareaValue(newValue);
    setFieldValue("name", newValue, true);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit();
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        {showWarning && (
          <Box sx={{ paddingX: "2rem", mt: "1.5rem" }}>
            <Paragraph sx={{ color: `${theme?.colors?.warning}` }}>Warning: Missing Information</Paragraph>
            <Paragraph>
              <Text sx={{ color: `${theme?.colors?.danger}` }}>Please check the "Need Info" section to avoid missing critical details required for completing this process.</Text>
              <Link sx={{ cursor: "pointer", mx: "8px" }} onClick={() => {
                const highlighte = highlighter?.find((highlighte: any) => highlighte?.name === 'Need Info');
                if (highlighte) {
                  handleHighlightClick?.(highlighte);
                } else {
                  toast.error("No need info added")
                }
              }}>Click here</Link>
            </Paragraph>
          </Box>
        )}
        {!(isStageMatch === false && ["Revision", "Background Change", "Plan Check"].includes(selectedHighlight?.name || "")) && (

          <Box sx={{ paddingX: "2rem", position: "relative" }}>
            <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
              {(is_Task_Worker && rolePermissionsHighLighters.includes(selectedHighlight?.name || "")) ? (
                <CustomTooltip id={placeholderText + 1213} title={is_Task_Worker && "Permission Denied"}>
                  <Textarea
                    ref={textareaRef}
                    disabled={!isStageMatch || is_Task_Worker}
                    placeholder={placeholderText}
                    name={"name"}
                    className="form-control mt-4"
                    value={values.name}
                    onChange={handleTextareaChange}
                    onKeyDown={handleKeyDown}
                    rows={1}
                    sx={{
                      width: '100%',
                      overflow: 'hidden',
                      height: '48px',
                      background: modalHeader,
                      color: titleHeader,
                      border: '1px solid rgba(255,255,255,0.06)',
                      borderRadius: '8px',
                      px: 3,
                      py: 2,
                      paddingRight: '40px',
                      '::placeholder': { color: titleHeader, opacity: 0.6 },
                      // Ensure focus does not get overridden by external .form-control styles
                      '&:focus, &:focus-visible': {
                        outline: 'none',
                        boxShadow: '0 0 0 3px rgba(99,102,241,0.12)',
                        background: modalHeader + " !important",
                        color: titleHeader + " !important",
                        borderColor: 'rgba(255,255,255,0.06)'
                      }
                    }}
                  />
                </CustomTooltip>
              ) : (
                <Textarea
                  ref={textareaRef}
                  placeholder={placeholderText}
                  name={"name"}
                  className="form-control mt-4"
                  value={values.name}
                  onChange={handleTextareaChange}
                  onKeyDown={handleKeyDown}
                  rows={1}
                  sx={{
                    width: '100%',
                    overflow: 'hidden',
                    height: '48px',
                    background: modalHeader,
                    color: titleHeader,
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '8px',
                    px: 3,
                    py: 2,
                    paddingRight: '40px',
                    '::placeholder': { color: titleHeader, opacity: 0.6 },
                    // Prevent bootstrap / global .form-control:focus from forcing a white background
                    '&:focus, &:focus-visible': {
                      outline: 'none',
                      boxShadow: '0 0 0 3px rgba(99,102,241,0.12)',
                      background: modalHeader + " !important",
                      color: titleHeader + " !important",
                      borderColor: 'rgba(255,255,255,0.06)'
                    }
                  }}
                />
              )}
            </Box>
          </Box>

        )}
        {null}
        {uploadError && (
          <Box sx={{ paddingX: "2rem", mt: "10px" }}>
            <Text sx={{ color: 'red', fontSize: '12px' }}>
              {uploadError}
            </Text>
          </Box>
        )}
        {canAddTask && (
          <Box className="mx-5 m-3" sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {(is_Task_Worker && rolePermissionsHighLighters.includes(selectedHighlight?.name || "")) ? (
              <CustomTooltip id={"AddTask12"} title={is_Task_Worker && "Permission Denied"}>
                <Button
                  type='button'
                  disabled={!isStageMatch || is_Task_Worker}
                  sx={{
                    borderRadius: "8px",
                    paddingLeft: "12px",
                    cursor: "not-allowed"
                  }}
                >
                  <FaPlus className="mx-1" />Add
                </Button>
              </CustomTooltip>
            ) : (
              <Button
                type="submit"
                disabled={isCompleted || isUploading}
                sx={{ borderRadius: "8px", paddingLeft: "12px", cursor: `${(isCompleted || isUploading) ? "not-allowed" : "pointer"}` }}
              >
                <FaPlus className="mx-1" />Add
              </Button>
            )}
          </Box>
        )}
      </form>
      <Divider sx={{ mt: "1.5rem" }} />
      <Box sx={{ display: "grid", paddingX: "2rem", gap: "1rem", position: "relative" }}>
        <Box className="row">
          <Box className="col-6">
            <Paragraph sx={{ fontSize: "18px", fontWeight: "600", mb: "0.5rem", color: colorMode === "light" ? "#212529" : "white" }}>{"All the reply and conversations"}</Paragraph>
          </Box>
          {/* {selectedHighlight?.name !== "Delivery Notes" && (
            <Box className="col-6">
              <FormSelect
                placeholder="Predefined Checklist"
                options={templateOptions}
                value={templateOptions?.find((option: any) => selectedTemplates?._id === option.value)}
                onChange={handleTemplateChange}
                scrollable={true}
                disabled={!isStageMatch &&
                  ["Revision", "Background Change", "Plan Check"]?.includes(selectedHighlight?.name || "")}
              />
            </Box>
          )} */}
          {['Background Change', 'Plan Check', 'Revision']?.includes(selectedHighlight?.name || "") &&
            (!is_Task_Worker && !rolePermissionsHighLighters.includes(selectedHighlight?.name || "")) && <Box className="col-6">
              {children}
            </Box>
          }
        </Box>

        {isDocMatch && actionHighlights?.payload?.Description?.length > 0 && actionHighlights?.payload?.Description?.map((action: any, index: number) => {

          return (<>

            <Card sx={{ background: modalHeader }}>
              {['Need Info', 'Delivery Notes', 'New Info Added', 'Blocked By Trade'].includes(selectedHighlight?.name || "") && (
                <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text variant="activityText" sx={{ border: 'none', fontWeight: 500 }}>
                    {action.createdBy ? action.createdBy : ''}
                  </Text>
                  <Text sx={{ fontSize: '12px', color: '#8F9195' }}>
                    {moment(action?.createdAt).format('MMM DD, LT')}
                  </Text>
                </Flex>
              )}
              <ActionCard key={index} index={index} action={{ ...action }} selectedHighlight={selectedHighlight} comment={false} keys={keys} actionObject={actionObject} />
            </Card>
          </>)

        }
        )}
        {loader && <Box sx={{ position: "absolute", inset: "0", width: "100%", height: "100%", backgroundColor: 'rgba(255, 255, 255, 0.5)', display: "grid", placeContent: "center" }}><Spinner /></Box>}
      </Box>
    </>
  )
}
